import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, switchMap } from 'rxjs';
import { RouteEntity } from '@core/router/route.entity';
import { RxEffects } from '@rx-angular/state/effects';
import { B2bProgramsState } from '../../../shared/state/b2b-programs-state';
import { PartnerProgram } from '@api/models/B2bService/Contract/partner-program';
import { SetB2BProgramRequest } from '@api/models/B2bService/Contract/set-b-2-b-program-request';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { AsyncPipe } from '@angular/common';
import { PushCodeModel } from '@core/push/push-code.model';
import { PushService } from '@core/push/push.service';
import { b2bProgramUnitList } from '../../../shared/models/b2b-program-unit.model';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { b2bProgramRateList } from '../../../shared/models/b2b-program-rate.model';
import { B2BPartnerListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { B2BVisOrgListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-vis-org-list-response';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import { map } from 'rxjs/operators';
import { DisplayPhonePipe } from '@ui/pipes/display-phone/display-phone.pipe';
import {
    ProgramSingleProductFormComponent,
} from '../../program-add/program-form/program-single-product-form/program-single-product-form.component';
import { B2bProgramType } from '../../../shared/models/b2b-program-type';
import {
    ProgramNumberOfTripsFormComponent,
} from '../../program-add/program-form/program-number-of-trips-form/program-number-of-trips-form.component';
import { parseNumber } from '@libs/functions';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-page-program-info',
    templateUrl: './program-info.component.html',
    styleUrls: ['./program-info.component.scss'],
    imports: [AsyncPipe, DisplayPhonePipe, ProgramSingleProductFormComponent, ProgramNumberOfTripsFormComponent, TranslatePipe],
    providers: [RxEffects],
})
export class ProgramInfoComponent {
    readonly #b2bProgramsState: B2bProgramsState = inject(B2bProgramsState);
    readonly #effects: RxEffects = inject(RxEffects);
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #router: Router = inject(Router);
    readonly #push: PushService = inject(PushService);

    public readonly prgId: number = parseNumber(this.#route.parent?.snapshot.paramMap.get(RoutingQueryParamsName.PrgId));
    public readonly units: AbstractListModel[] = b2bProgramUnitList;
    public readonly rateTypes: AbstractListModel[] = b2bProgramRateList;
    public readonly b2bProgramType: typeof B2bProgramType = B2bProgramType;

    public readonly data$: Observable<{ b2bProgram: PartnerProgram }> = this.#route.parent?.data as Observable<{
        b2bProgram: PartnerProgram;
    }>;

    public readonly partners$: Observable<B2BPartnerListResponse[]> = this.#b2bProgramsState.partners$;
    public readonly partnerInfo$: Observable<B2BVisOrgListResponse> = this.data$?.pipe(
        switchMap((data: { b2bProgram: PartnerProgram }) =>
            this.#b2bProgramsState.organizations$.pipe(
                map((orgs: B2BVisOrgListResponse[]) => orgs.find((org: B2BVisOrgListResponse) => org.orgId === data.b2bProgram.orgId)),
            ),
        ),
    );

    public readonly pending$: Observable<boolean> = this.#b2bProgramsState.loading$.pipe(
        getLoadingProp(StartWithUnit.RequestUpdateB2BProgram),
    );

    public isEditUser$: Observable<boolean>;
    public b2bProgram: PartnerProgram;

    public editB2bProgram(body: SetB2BProgramRequest): void {
        this.#effects.register(this.#b2bProgramsState.updateProgram(body), () =>
            this.#router.navigate([RouteEntity.Root, RouteEntity.Programs]).then(() => this.#push.success(PushCodeModel.SuccessChange)),
        );
    }
}
